module.exports = "button{\r\n    white-space: pre-wrap !important;\r\n  }"